const dateUtil = {
  unix2date(unixTime, type) {
    let str = "";
    if ("" != unixTime && unixTime > 0) {
      let time = new Date(unixTime * 1000);

      let vYear = time.getFullYear();
      let vMon = time.getMonth() + 1;
      let vDay = time.getDate();
      let vHour = time.getHours();
      let vMin = time.getMinutes();
      let vSec = time.getSeconds();

      vMon = (vMon < 10 ? "0" + vMon : vMon);
      vDay = (vDay < 10 ? "0" + vDay : vDay);
      vHour = (vHour < 10 ? "0" + vHour : vHour);
      vMin = (vMin < 10 ? "0" + vMin : vMin);
      vSec = (vSec < 10 ? "0" + vSec : vSec);

      if (0 == type) {
        str += vYear + "-" + vMon + "-" + vDay;
      } else if (1 == type) {
        str += vYear + "-" + vMon + "-" + vDay;
        str += " " + vHour + ":" + vMin + ":" + vSec;
      } else if (2 == type) {
        str += vYear + "-" + vMon + "-" + vDay;
        str += " " + vHour + ":" + vMin;
      } else if (3 == type) {
        str += vYear + "." + vMon + "." + vDay;
      } else {
        str += vYear + "-" + vMon + "-" + vDay;
      }
    }
    return str;
  },

  /**
   * 获得某天的时间戳
   */
  get_now_unixstamp() {
    const d = new Date();
    const timestamp = Date.parse(d);
    const dTime = (timestamp / 1000);
    return dTime;
  },

  /**
   * 获得某天的时间戳
   */
  get_unixstamp(year, month, day) {
    const d = new Date(year, month, day, 0, 0, 0);
    const timestamp = Date.parse(d);
    const dTime = (timestamp / 1000);
    return dTime;
  },
  init_times(type, hour, oDate, month_num) {
    let start_hour = " 00:00";
    let end_hour = " 23:59";
    if (1 == hour) {
      start_hour = "";
      end_hour = "";
    } else if (2 == hour) {
      start_hour = " 00:00";
      end_hour = " 23:59";
    }
    let dtTmp = new Date();//("2016-12-12 12:12:12");
    if (null != oDate && undefined != oDate && "" != oDate) {
      dtTmp = oDate;
    }
    const timestamp = Date.parse(dtTmp);
    const nowTime = (timestamp / 1000);

    const today = this.unix2date(nowTime, 0);
    const yesterday = this.unix2date(nowTime - 86400, 0);
    const yesterday2 = this.unix2date(nowTime - (86400 * 2), 0);
    const yesterday7 = this.unix2date(nowTime - (86400 * 6), 0);
    const yesterday8 = this.unix2date(nowTime - (86400 * 7), 0);
    const yesterday30 = this.unix2date(nowTime - (86400 * 29), 0);
    const yesterday31 = this.unix2date(nowTime - (86400 * 30), 0);

    let week = dtTmp.getDay();
    if (0 == week) {
      week = 7;
    }
    const monday_u = nowTime - (86400 * (week - 1));
    const monday = this.unix2date(monday_u, 0);
    const last_week_s = this.unix2date(monday_u - (86400 * 7), 0);
    const last_week_e = this.unix2date(monday_u - 86400, 0);

    const dtTmp_year = dtTmp.getFullYear();
    const dtTmp_month = dtTmp.getMonth();

    const month_u = this.get_unixstamp(dtTmp_year, dtTmp_month, 1);
    const month = this.unix2date(month_u, 0);

    let last_year, last_month, prve_year, prve_month;
    if (0 == dtTmp_month) {
      last_year = dtTmp_year - 1;
      last_month = 11;
      prve_year = dtTmp_year;
      prve_month = dtTmp_month + 1;
    } else if (11 == dtTmp_month) {
      prve_year = dtTmp_year + 1;
      prve_month = 0;
      last_year = dtTmp_year;
      last_month = dtTmp_month - 1;
    } else {
      prve_year = dtTmp_year;
      last_year = dtTmp_year;
      last_month = dtTmp_month - 1;
      prve_month = dtTmp_month + 1;
    }
    const prve_month_u = this.get_unixstamp(prve_year, prve_month, 1);
    const month_e = this.unix2date(prve_month_u - 86400, 0);
    const last_month_s = this.unix2date(this.get_unixstamp(last_year, last_month, 1), 0);
    const last_month_e = this.unix2date(month_u - 86400, 0);

    let start_time = "";
    let end_time = "";
    if ("t1" == type) { //今天
      start_time = today + start_hour;
      end_time = today + end_hour;
    } else if ("t2" == type) { //昨天
      start_time = yesterday + start_hour;
      end_time = yesterday + end_hour;
    } else if ("t3" == type) { //前天
      start_time = yesterday2 + start_hour;
      end_time = yesterday2 + end_hour;
    } else if ("t4" == type) { //最近七天
      start_time = yesterday7 + start_hour;
      end_time = today + end_hour;
    } else if ("t4-1" == type) { //最近七天 不包括今天
      start_time = yesterday8 + start_hour;
      end_time = yesterday + end_hour;
    } else if ("t5" == type) { //最近30天
      start_time = yesterday30 + start_hour;
      end_time = today + end_hour;
    } else if ("t5-1" == type) { //最近30天 不包括今天
      start_time = yesterday31 + start_hour;
      end_time = yesterday + end_hour;
    } else if ("t6" == type) { //本周
      start_time = monday + start_hour;
      end_time = today + end_hour;
    } else if ("t7" == type) { //上周
      start_time = last_week_s + start_hour;
      end_time = last_week_e + end_hour;
    } else if ("t8" == type) { //本月初到当日
      start_time = month + start_hour;
      end_time = today + end_hour;
    } else if ("t9" == type) { //上月
      start_time = last_month_s + start_hour;
      end_time = last_month_e + end_hour;
    } else if ("t10" == type) { //本月初到本月低
      start_time = month + start_hour;
      end_time = month_e + end_hour;
    } else if ("t11" == type) { //本月当日到本月低
      start_time = this.unix2date(init_nowtime(), 0) + start_hour;
      end_time = month_e + end_hour;
    } else {
      start_time = "";
      end_time = "";
    }
    let times = new Array();
    times[0] = start_time;
    times[1] = end_time;
    return times;
  }
}
export default dateUtil;



// WEBPACK FOOTER //
// ./src/utility/dateUtil.js